import { render, staticRenderFns } from "./landingCover.vue?vue&type=template&id=8b9b00c0&"
import script from "./landingCover.vue?vue&type=script&lang=js&"
export * from "./landingCover.vue?vue&type=script&lang=js&"
import style0 from "./landingCover.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports